<template lang="pug">
v-container(fluid pa-0 class="tw-mb-2")
  v-row(dense class="")
    v-col(cols="12" class="tw-rounded tw-overflow-hidden tw-py-1 ")
      router-link(:to="{ path: 'listing/' + this.$faker().datatype.number() }")
        v-card(class="tw-relative tw-shadow-md ")
          v-img(:src="image" aspect-ratio="1.1" class="tw-rounded-md tw-overflow-hidden")
          v-card-title(
            class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-mx-4 tw-mb-2 tw-p-3 tw-flex tw-items-center tw-justify-between tw-rounded-md"
          )
            div
              div(class="tw-font-bold tw-text-lg") Gorgeous Villa Bay
              div(class="tw-text-sm tw-text-gray-600") 18 Grattan St, Brooklyn
            v-chip(class="tw-bg-white tw-font-bold tw-text-base") $4,800
</template>
<script>
export default {
  data() {
    return {
      image: null,
    };
  },

  mounted() {
    this.$store.dispatch('properties/getPexelImage').then((response) => {
      this.image = response;
    });
  },
};
</script>
